import { useCallback } from "react";
import { Pressable } from "react-native";

import { Icon } from "../lib";

type Props = {
  active?: boolean;
  onPress: (value: number) => void;
  value: number;
};

export function ButtonStar({ active = false, onPress, value }: Props) {
  const handlePress = useCallback(() => {
    onPress(value);
  }, [onPress, value]);

  return (
    <Pressable onPress={handlePress}>
      <Icon em large name={active ? "star" : "star-outline"} />
    </Pressable>
  );
}
